import { basemapStyles } from "../components/Map/basemapStyles";

export const initialMapState = {
  lat: 34.213,
  lon: -85.712,
  zoom: 3,
  basemap: basemapStyles["Light"],
};